// extracted by mini-css-extract-plugin
export default {"loadingGroup":"loadingGroup--l7eum","switch":"switch--bZ0C8"};